<div class="card-atlas h-100">
	<div class="d-flex justify-content-between">
		<ng-container *ngTemplateOutlet="cardHeader"></ng-container>
	</div>
	<div class="mt-2">
		<ng-container *ngTemplateOutlet="cardBody"></ng-container>
	</div>
</div>
